import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import PlaceholderSection from '~/components/Section/PlaceholderSection';
import CustomizeBox from '~/components/Customize/CustomizeBox';
import Topic from '~/components/Topic/Topic';

const CustomizeBoxContainer = styled.div`
  margin: 24px auto;
`;
export default class InfiniteScrollSearch extends Component {
  static propTypes = {
    topics: PropTypes.array,
    search: PropTypes.func,
    searching: PropTypes.bool,
    appending: PropTypes.bool,
    filtering: PropTypes.bool,
    isEnd: PropTypes.bool,
    loadedDataCount: PropTypes.number,
    query: PropTypes.object,
    focus: PropTypes.string,
  };

  componentDidMount() {
    window.addEventListener(
      'scroll',
      (this.handleScroll = () => {
        const screenHeight = window.innerHeight
          || window.document.documentElement.clientHeight
          || window.document.body.clientHeight;
        const scrollTop = window.scrollY
          || window.document.documentElement.scrollTop;
        const scrollBottom = scrollTop + screenHeight;
        const height = window.document.body.scrollHeight;
        if (
          scrollBottom + screenHeight > height
          && !this.props.searching
          && !this.props.isEnd
        ) {
          this.loadMore();
        }
      }),
      { passive: true }
    );
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.handleScroll = null;
  }

  loadMore = () => {
    const skip = this.props.loadedDataCount;
    this.props.search(skip, true);
  };

  render() {
    const { topics, searching, appending, filtering, focus, query } = this.props;
    return (
      <Fragment>
        {filtering && <PlaceholderSection />}
        {(!topics || topics.length < 1) && <CustomizeBoxContainer><CustomizeBox /></CustomizeBoxContainer>}
        {!filtering && topics && topics.map((topic, index) => ([
          <Topic
            {...this.props}
            key={`topic-${topic._id}`}
            topic={topic}
            showAll={query.type === 'local-experts' || (focus && index === 0)}
            index={index}
          />,
          (index % 5 === 4) || (topics.length < 5 && index === topics.length - 1) ? <CustomizeBoxContainer><CustomizeBox key={`customize-${index}`} /></CustomizeBoxContainer> : <div />
        ]))}
        {searching && appending && <PlaceholderSection />}
      </Fragment>
    );
  }
}
